import { atom } from "jotai"

export const INIT_POSITION = {
    posId: null,
    posCode: "",
    posName: "",
    orgId: null,
    deptId: null,
    divId: null,
    status: 'true',
    submissionUserId: '',
    approverUserId: '',
    posResourceTotal: null,
}

export const positionAtom  = atom(INIT_POSITION)
